import _classCallCheck from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { VisualElement } from '../VisualElement.mjs';
import { DOMKeyframesResolver } from './DOMKeyframesResolver.mjs';

var DOMVisualElement = /*#__PURE__*/function (_VisualElement) {
  _inherits(DOMVisualElement, _VisualElement);

  var _super = _createSuper(DOMVisualElement);

  function DOMVisualElement() {
    var _this;

    _classCallCheck(this, DOMVisualElement);

    _this = _super.apply(this, arguments);
    _this.KeyframeResolver = DOMKeyframesResolver;
    return _this;
  }

  _createClass(DOMVisualElement, [{
    key: "sortInstanceNodePosition",
    value: function sortInstanceNodePosition(a, b) {
      /**
       * compareDocumentPosition returns a bitmask, by using the bitwise &
       * we're returning true if 2 in that bitmask is set to true. 2 is set
       * to true if b preceeds a.
       */
      return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
  }, {
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps(props, key) {
      return props.style ? props.style[key] : undefined;
    }
  }, {
    key: "removeValueFromRenderState",
    value: function removeValueFromRenderState(key, _ref) {
      var vars = _ref.vars,
          style = _ref.style;
      delete vars[key];
      delete style[key];
    }
  }]);

  return DOMVisualElement;
}(VisualElement);

export { DOMVisualElement };